import { motion } from "framer-motion";
import { Globe, Plus } from "lucide-react";
import { useAuth } from "../../Auth/AuthContext";

export default function AppsWebHeader({ openModal }) {
  const { user } = useAuth();
  const isAdmin = user?.role === "Admin";
  return (
    <motion.div
      className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="flex items-center gap-3">
        <div className="p-2.5 rounded-xl bg-indigo-100">
          <Globe className="w-5 h-5 text-indigo-600" />
        </div>
        <div>
          <h2 className="text-xl md:text-2xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">
            Apps & Websites
          </h2>
          <p className="text-xs text-gray-500 mt-0.5">Manage publisher properties and their approval status</p>
        </div>
      </div>
      {isAdmin && (
        <motion.button
          onClick={openModal}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.97 }}
          className="flex items-center gap-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-5 py-2.5 rounded-xl shadow-lg hover:shadow-xl hover:brightness-110 transition-all"
        >
          <Plus className="w-4 h-4" />
          Add Property
        </motion.button>
      )}
    </motion.div>
  );
}
